import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { WhatsAppFloatingButton } from './components/WhatsAppButton';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="2wjql9i09eorx">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="28ufpkexrnkkn">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="28t4j27cxrypu">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="23vupqgmff2wq">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3mlat8v8bdto6">
      <UrgencyBanner data-id="element-5" data-mp="3rdarmj8qkein" />
      <main data-id="element-6" data-mp="3rd1azm9kzjpm">
        <Hero data-id="element-7" data-mp="3reccfffk0fdk" />
        <PackContents data-id="element-8" data-mp="5yj0slx59ec" />
        <InitialTestimonials data-id="element-9" data-mp="6htxpd5ixiv" />
        <PainPoints data-id="element-10" data-mp="5gez9t0lqvv" />
        <MethodOverview data-id="element-11" data-mp="82kl3wchwbg" />
        <MoreTestimonials data-id="element-12" data-mp="2zld1d7i6tbah" />
        <Guarantee data-id="element-13" data-mp="2zlv32jnmchps" />
        <FAQ data-id="element-14" data-mp="2zmo557bmuj1l" />
        <CostComparison data-id="element-15" data-mp="2zmwh8wzxlkbq" />
        <TransitionPhrase data-id="element-16" data-mp="33mow1rfx4mpj" />
        <EmotionalClose data-id="element-17" data-mp="33lwywc6oagx5" />
      </main>
      <Footer data-id="element-18" data-mp="33mymth8sexwa" />
      <FloatingNotification data-id="element-19" data-mp="33orkw85c49so" />
      <WhatsAppFloatingButton data-id="element-20" data-mp="38l8hzruihyhw" />
    </div>;
}